<template>
  <div>
    <!-- Page content -->
    <b-container>
      <b-row class="justify-content-center mt-5 mb-5">
        <b-col lg="5" md="7">
          <b-card no-body>
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <div class="auth-logo">
                  <img src="@/assets/img/moolah-icon-blue-lg.png" />
                </div>
                <small>Enter and confirm your new password.</small>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    class="mb-3"
                    name="password"
                    ref="password"
                    mode="lazy"
                    :rules="{ required: true, min: 8 }"
                    prepend-icon="fa-solid fa-lock"
                    type="password"
                    placeholder="Password"
                    v-model="model.password"
                  >
                  </base-input>
                  <div class="mt--4 mb-3 text-muted">
                    <small>
                      At least 8 characters, 1 digit, and 1 symbol
                    </small>
                  </div>

                  <base-input
                    class="mb-3"
                    name="password2"
                    ref="password2"
                    mode="lazy"
                    :rules="{ required: true, min: 8 }"
                    prepend-icon="fa-solid fa-lock"
                    type="password"
                    placeholder="Confirm Password"
                    v-model="model.password2"
                  >
                  </base-input>

                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4 btn-block"
                      >Set Password</base-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-4">
            <b-col cols="12">
              <small
                ><router-link to="/login" class="text-muted"
                  >Login</router-link
                ></small
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  inject: ["systemContextService"],
  data() {
    return {
      logo: null,
      model: {
        id: "",
        password: "",
        password2: "",
      },
    };
  },
  created() {
    this.logo = this.systemContextService.getSystem().dashboardImageUrl;
  },
  methods: {
    onSubmit() {
      var self = this;

      this.$emitter.on("response-validationErrors", (e) => {
        self.$refs.formValidator.setErrors(e.errors);
      });

      self.model.id = self.$route.params.id;

      this.$client
        .post("/api/auth/setPassword", this.model)
        .then((response) => {
          if (response.data.isSuccess) {
            self.$emitter.emit("success", {
              message: "Your pasword has been reset, you may now login.",
              title: "New Password Set",
            });
            self.$router.push({ path: "/" });
          }
        });
    },
  },
};
</script>
<style lang="scss"></style>
